<template lang="pug">
  .select-technician
    div
      button.change-button(
        :disabled="disabled || loading"
        @click="ingresar()")
        b-spinner(v-if="loading" small)
        span {{ loading ? 'Procesando...' : 'Ingresar a bodega' }}
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionIngresarABodega',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  methods: {
    ...mapActions('OTStore', ['ingresarABodega', 'getOT']),
    async ingresar() {
      try {
        await this.executeWithLoading(async () => {
          const payload = { ot: this.ot.ot }
          const resp = await this.ingresarABodega(payload)
          if (resp.status === 200) {
            this.$bvToast.toast('OT ingresada a bodega correctamente', {
              variant: 'success',
            })
            this.$emit('changed')
            await this.getOT(this.ot.ot)
          } else {
            this.$bvToast.toast(`Error al ingresar a bodega: ${resp.data}`, {
              variant: 'danger',
            })
          }
        })
      } catch (error) {
        console.error('Error al ingresar a bodega:', error)
        this.$bvToast.toast('Error al ingresar a bodega', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
